export default __webpack_public_path__ + "static/media/Premiumspacepro.18ab97aa.webp";